const styles = () => ({
    actionsContainer: {
        flex: 1,
        padding: '30px',
        margin: '50px 12px 0 12px',
        display: 'flex',
        backgroundColor: 'rgba(0, 0, 0, 0.05)',
    },
    actionsBtns: {
        borderRadius: '20px',
        width: '190px',
        height: '40px',
    },
    colorWhite: {
        color: '#fff',
    },
    title: {
        fontWeight: '500',
        marginBottom: '0',
    },
    subtitle: {
        fontWeight: '400',
        marginBottom: '0',
    },
    verticalMiddle: {
        display: 'flex',
        alignItems: 'center',
        fontSize: '1rem',
    },
    positionRelative: {
        position: 'relative',
    },
    centerProgress: {
        marginTop: '20px',
        textAlign: 'center',
    },
    radioGroup: {
        width: '100%',
        display: 'flex',
    },
    circularProgress: {
        position: 'absolute',
        top: '23px',
        right: '40px',
    },
    selectPlate: {
        minWidth: '150px',
    },
    loadingCRLV: {
        marginBottom: '10px',
        marginLeft: '12px',
    },

    boxCount: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-evenly',
        maxWidth: '350px',
        borderTop: '1px solid #d8d8d8',
        padding: '15px 58px',
        marginLeft: 'auto',
        marginBottom: '20px',

        '& strong': {
            fontSize: '16px',
            fontFamily: 'inherit',
            fontWeight: 500,
            textTransform: 'uppercase',
            color: '#747474',
            marginTop: '5px',
        },

        '& span': {
            width: '50px',
            height: '50px',
            background: '#8db9d2',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            borderRadius: '100%',
            fontSize: '16px',
            fontWeight: 'bold',
            fontFamily: 'inherit',
            color: '#fff',
            margin: '5px',
        },
    },
});

export default styles;
